/**
 * Optional, gentle haptics — earned at exactly two moments: making a choice, and
 * a right answer. A soft tick, never a buzz.
 *
 * Guarded three ways: the API must exist, the user must not have asked to reduce
 * motion (a calm request we honour for touch too), and the pattern is tiny.
 */

function reduceMotion(): boolean {
  return (
    typeof window !== "undefined" &&
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
  );
}

/** A single soft tick. No-op where vibration is unavailable or motion is reduced. */
export function hapticTick(): void {
  if (typeof navigator === "undefined" || typeof navigator.vibrate !== "function") {
    return;
  }
  if (reduceMotion()) return;
  try {
    navigator.vibrate(10);
  } catch {
    /* some browsers throw if called outside a gesture — ignore */
  }
}
